import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=38489449"
import script from "./Academy.vue?vue&type=script&lang=js"
export * from "./Academy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports